import type { ModalProps } from "antd";
import { Modal } from "antd";

export default function AntModal(props: ModalProps) {
  return (
    <Modal
      closeIcon={null}
      footer={null}
      destroyOnClose
      width={600}
      className="[&>div>.ant-modal-content]:!p-0 [&>div>.ant-modal-content]:!shadow-lg"
      {...props}
    >
      {props.children}
    </Modal>
  );
}
